import { Instrument } from '@toro/common/shared/models/quote/instrument.model';
import { TrendModel } from '@toro/common/shared/models/stocks-exchange/trend-stock.model';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import { StocksExploreMarketAction } from './stock-explore-market.action';

export class StocksExploreMarketState {
    public pending: boolean;
    public searchStocks: Instrument[];
    public stocks: any[];
    public trend: TrendModel;
}

export const initialState: StocksExploreMarketState = {
    pending: false,
    searchStocks: null,
    stocks: [],
    trend: new TrendModel(),
};

export function StocksExploreMarketReducer(state: StocksExploreMarketState = initialState, action?: StocksExploreMarketAction) {

  switch (action.type) {

    /** Filtros de explore o mercado */
    case StocksExploreMarketAction.getTrends:
        return {...state, ...{ pending: true}};
    case StocksExploreMarketAction.getTrendsError:
        return {...state, ...{ pending: false }};
    case StocksExploreMarketAction.getMostTrendSuccess:
        return {...state, ...{ trend: {...state.trend, ...{ mostTraded: action.payload } }, pending: false }};
    case StocksExploreMarketAction.getIsLowTrendSuccess:
        return {...state, ...{ trend: {...state.trend, ...{ isLow: action.payload } }, pending: false }};
    case StocksExploreMarketAction.getIsUpTrendSuccess:
        return {...state, ...{ trend: {...state.trend, ...{ isUp: action.payload } }, pending: false }};
    case StocksExploreMarketAction.getCanDownTrendSuccess:
        return {...state, ...{ trend: {...state.trend, ...{ canDown: action.payload } }, pending: false }};
    case StocksExploreMarketAction.getCanUpTrendSuccess:
        return {...state, ...{ trend: {...state.trend, ...{ canUp: action.payload } }, pending: false }};

    /** Busca por ativos */
    case StocksExploreMarketAction.searchStock:
        return {...state, ...{ pending: true}};
    case StocksExploreMarketAction.searchStockError:
        return {...state, ...{ pending: false }};
    case StocksExploreMarketAction.searchStockSuccess:
    return {...state, ...{ searchStocks: UtilitiesService.normalizeSecturityCategory(action.payload), pending: false }};
    case StocksExploreMarketAction.cleanSearchStock:
        return {...state, ...{ pending: false, searchStocks: null}};

    default:
        return state;
  }
}
